import { TextIcon } from '@radix-ui/react-icons'
import { TagIcon } from '@heroicons/react/24/outline'
import { ToolbarSplitButton, DropdownOption } from './ToolbarSplitButton'
import { useDocumentState } from '@/state'
import { useCADQuery } from '@/services/queries/cads'
import {
  OperationNotesPlaceholder,
  OperationLabelPlaceholder,
} from './DraggablePlaceholders'

type TextMenuProps = {
  isDisabled: boolean
}

export const TextMenu = ({ isDisabled }: TextMenuProps) => {
  const selectedPageId = useDocumentState((state) => state.currentPageInView)
  const startAddingElement = useDocumentState(
    (state) => state.startAddingElement,
  )

  const { data: cadData } = useCADQuery()
  const documentPage = cadData?.documentPages.find(
    (page) => page.id === selectedPageId,
  )

  const handleTextbox = (e: React.MouseEvent) => {
    if (!documentPage) return

    startAddingElement({
      newElementData: {
        Component: OperationNotesPlaceholder,
        dataType: 'note',
        attributes: {
          content: '',
          notesPosition: 'absolute',
        },
        documentPageId: documentPage?.id as string,
      },
      triggerLocation: {
        x: e.clientX,
        y: e.clientY,
      },
    })
  }

  const handleLabel = (e: React.MouseEvent) => {
    if (!documentPage) return

    startAddingElement({
      newElementData: {
        Component: OperationLabelPlaceholder,
        dataType: 'label',
        attributes: {
          content: '',
          notesPosition: 'absolute',
        },
        documentPageId: documentPage?.id as string,
      },
      triggerLocation: {
        x: e.clientX,
        y: e.clientY,
      },
    })
  }

  const defaultOption: DropdownOption = {
    title: 'Textbox',
    description: 'Paragraphs',
    Icon: TextIcon,
    handler: handleTextbox,
  }

  const dropdownOptions: DropdownOption[] = [
    {
      title: 'Label',
      description: 'Limited text space',
      Icon: TagIcon,
      handler: handleLabel,
    },
  ]

  return (
    <ToolbarSplitButton
      Icon={TextIcon}
      defaultAction={handleTextbox}
      defaultOption={defaultOption}
      dropdownOptions={dropdownOptions}
      tooltip="Paragraphs"
      isDisabled={isDisabled}
    />
  )
}
